// Angular
import { Component, OnChanges, AfterContentInit } from '@angular/core';
import { OnInit, OnDestroy } from '@angular/core';
import { Output, EventEmitter, SimpleChange } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

// Services
import { AuthService } from 'app/_services';
import { EntryService } from 'app/_services';

// Models
import { Theme } from 'app/_models';

// 3rd Party
import * as _ from 'underscore';
import { NgForage, NgForageCache } from 'ngforage';

@Component({
    selector: 'headermenu',
    templateUrl: 'headermenu.component.html',
    styleUrls: ['./headermenu.component.scss'],
    providers: [
        EntryService,
        NgForage,
        NgForageCache
    ]
})

export class HeaderMenuComponent implements OnInit, OnDestroy, OnChanges, AfterContentInit {
    @Output() change: EventEmitter<any> = new EventEmitter<any>();

    private bearerToken = '';

    public menuItems: any;

    public themeData: Theme = new Theme();

    constructor(
        private httpClient: HttpClient,
        private entryService: EntryService,
        private ngf: NgForage,
    ) {
        let authService: AuthService = new AuthService();

        this.bearerToken = authService.getToken();
    }

    public initData(data: any) {
        console.log('NavMenuComponent: initData');
    }

    public showMenu(item): boolean {
        return _.isNull(item.devOnly) ? true : !item.devOnly;
    }

    private initMenu(menu: any): void {
        this.menuItems = menu;
    }

    private loadMenu(): Promise<any> {
        const sUrl = `/assets/menu.json`;

        return this.httpClient
            .get(sUrl)
            .toPromise()
            .then(response => {
                return response || {};
            });
    }

    ngAfterContentInit() {
        console.log('NavMenuComponent: ngAfterContentInit');
    }

    ngOnInit() {
        console.log('NavMenuComponent: ngOnInit');

        this.loadMenu().then(result => {
            this.initMenu(result);
        });

        this.entryService.getAction().subscribe(data => {
            if (data['action']) {
                const action = data['action'];

                if (action === 'ThemeChange') {
                    this.themeData = data['value'];
                }
            }
        });

        this.ngf.getItem<Theme>('theme')
            .then(data => {
                if (data) {
                    this.themeData = data;
                } else {
                    this.ngf.setItem('theme', this.themeData);
                }
            });
    }

    ngOnDestroy() {
        console.log('NavMenuComponent: ngOnDestroy');
    }

    ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
        console.log('NavMenuComponent: ngOnChanges');
    }
}
